// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../library/network/CrmNetwork.bs.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CancelOrderPayload from "../entity/CancelOrderPayload.bs.js";
import * as OrderStatusPayload from "../entity/OrderStatusPayload.bs.js";
import * as DeliveryNotePayload from "../entity/DeliveryNotePayload.bs.js";
import * as EditOrderRepoConfig from "./EditOrderRepoConfig.bs.js";
import * as HasWaypointsPayload from "../entity/HasWaypointsPayload.bs.js";
import * as DryRunDistancePayload from "../entity/DryRunDistancePayload.bs.js";
import * as ActualPartnerCollectedCashPayload from "../entity/ActualPartnerCollectedCashPayload.bs.js";

function fetchManualEditOrderReasons(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/manual_reasons_for_edit";
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.ManualEditOrderReasonsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchOrderCancellationReasons(order_status, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/v1/crm/order/cancellation_reasons?order_status=" + order_status);
  return NetworkUtils.catchPromiseError(CrmNetwork.get(requestUrl, undefined, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.OrderCancellationReasonsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function updateActualPartnerCollectedCash(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/update_actual_partner_collected_cash";
  var encodedPayload = JSON.stringify(ActualPartnerCollectedCashPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateActualPartnerCollectedCashResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function updateHasWaypoints(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/update_has_waypoint";
  var encodedPayload = JSON.stringify(HasWaypointsPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateHasWaypointsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function updateDryRunDistance(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/update_dryrun_distance";
  var encodedPayload = JSON.stringify(DryRunDistancePayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateDryRunDistanceResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function updateOrderStatus(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/update_status";
  var encodedPayload = JSON.stringify(OrderStatusPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateOrderStatusResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function cancelOrder(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/cancel";
  var encodedPayload = JSON.stringify(CancelOrderPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.CancelOrderResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function updateDeliveryNote(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v1/crm/order/delivery_note";
  var encodedPayload = JSON.stringify(DeliveryNotePayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(CrmNetwork.postRequestV2(requestUrl, undefined, encodedPayload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateDeliveryNoteResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var EditOrderRepo = {
  fetchManualEditOrderReasons: fetchManualEditOrderReasons,
  fetchOrderCancellationReasons: fetchOrderCancellationReasons,
  updateActualPartnerCollectedCash: updateActualPartnerCollectedCash,
  updateHasWaypoints: updateHasWaypoints,
  updateDryRunDistance: updateDryRunDistance,
  updateOrderStatus: updateOrderStatus,
  cancelOrder: cancelOrder,
  updateDeliveryNote: updateDeliveryNote
};

export {
  EditOrderRepo ,
  
}
/* Config Not a pure module */
